import React from "react";
import styled from "styled-components";
import {Spin} from "antd";
import {InboxOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {
    PopupContainer,
    Header,
    TitleContainer,
    Icon,
    Title,
    Section,
    SectionTitle,
    List,
    ListItem
} from "components/customer/customerHomePageWithShiftScore/style/CourierPopup.style";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";

const PopupTitleLink = styled.a`
    color: inherit;

    &:hover {
        color: #1890ff;
    }
`;

// Bölüm başlığı ile sağdaki detay linkini aynı satırda tutar
const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
`;

const SectionHeading = styled(SectionTitle)`
    margin-bottom: 0;
`;

const DetailLink = styled.a`
    display: flex;
    align-items: center;
    color: #8c8c8c;
    font-size: 16px;

    &:hover {
        color: #1890ff;
    }
`;

const SectionDivider = styled.div`
    border-top: 1px solid #f0f0f0;
    margin: 10px 0;
`;

const OrderTitle = styled(Title)`
    min-width: 0;
    flex: 1;
    overflow-wrap: anywhere;
    word-break: break-all;
`;

const deliveryStateLabels = {
    unassigned: "Kuyrukta Bekliyor",
    inQueue: "Kuyrukta Bekliyor",
    waiting: "Kurye Atandı",
    onTheWayForPickUp: "Taşıma Aşamasında",
    onPickUpAddress: "Taşıma Aşamasında",
    onDelivery: "Taşıma Aşamasında",
    onDeliveryAddress: "Taşıma Aşamasında",
    delivered: "Teslim Edildi"
};

export const MapOrderPopup = ({order, delivery, subCompanyDetail, subCompanyDetailLoading}) => {
    const pickup =
        delivery?.pickupInfos?.find(p => p._id === order?.pickupInfoId) ||
        delivery?.pickupInfos?.[0];
    const deliveryId = delivery?._id;
    const orderNumber = order?.orderNumber || delivery?.orders?.[0]?.orderNumber;
    const courierId = delivery?.assignedCourier?._id;
    const courierName = delivery?.assignedCourier?.fullname;
    const subCompanyId = pickup?._id;
    // Firma adı yalnızca alt firma detayı yüklendiğinde elimizde oluyor
    const companyName = subCompanyDetail?.company?.companyName;

    return (
        <PopupContainer>
            <Header>
                <TitleContainer>
                    <Icon>
                        <InboxOutlined />
                    </Icon>
                    <OrderTitle>
                        {deliveryId ? (
                            <PopupTitleLink
                                href={`/orders/${deliveryId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Shortener text={orderNumber} length={64} zIndex={10001} />
                            </PopupTitleLink>
                        ) : (
                            <Shortener text={orderNumber} length={64} />
                        )}
                    </OrderTitle>
                </TitleContainer>
            </Header>

            <Section>
                <SectionHeader>
                    <SectionHeading>Sipariş Bilgileri</SectionHeading>
                    {deliveryId ? (
                        <DetailLink
                            href={`/orders/${deliveryId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Sipariş Detayı"
                        >
                            <InfoCircleOutlined />
                        </DetailLink>
                    ) : null}
                </SectionHeader>
                <List>
                    <ListItem>
                        Durum:{" "}
                        {deliveryStateLabels[delivery?.deliveryState] || delivery?.deliveryState}
                    </ListItem>
                    <ListItem>Alıcı: {order?.receiverName || "-"}</ListItem>
                </List>
            </Section>

            <SectionDivider />

            <Section>
                <SectionHeader>
                    <SectionHeading>Kurye Bilgileri</SectionHeading>
                    {courierId ? (
                        <DetailLink
                            href={`/couriers/${courierId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Kurye Detayı"
                        >
                            <InfoCircleOutlined />
                        </DetailLink>
                    ) : null}
                </SectionHeader>
                <List>
                    <ListItem>
                        İsim:{" "}
                        {courierId && courierName ? (
                            <PopupTitleLink
                                href={`/couriers/${courierId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {courierName}
                            </PopupTitleLink>
                        ) : (
                            courierName || "-"
                        )}
                    </ListItem>
                    <ListItem>Telefon: {delivery?.assignedCourier?.cellPhone || "-"}</ListItem>
                </List>
            </Section>

            <SectionDivider />

            <Section>
                <SectionHeader>
                    <SectionHeading>Alt Firma Bilgileri</SectionHeading>
                    {subCompanyId ? (
                        <DetailLink
                            href={`/companies/sub-company/${subCompanyId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Alt Firma Detayı"
                        >
                            <InfoCircleOutlined />
                        </DetailLink>
                    ) : null}
                </SectionHeader>
                <List>
                    <ListItem>
                        Alt Firma:{" "}
                        {subCompanyId && pickup?.name ? (
                            <PopupTitleLink
                                href={`/companies/sub-company/${subCompanyId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {pickup.name}
                            </PopupTitleLink>
                        ) : (
                            pickup?.name || "-"
                        )}
                    </ListItem>
                    {companyName ? <ListItem>Firma: {companyName}</ListItem> : null}
                    <ListItem>
                        Telefon:{" "}
                        {subCompanyDetailLoading ? (
                            <Spin size="small" />
                        ) : (
                            subCompanyDetail?.authorizedPhone || "-"
                        )}
                    </ListItem>
                </List>
            </Section>
        </PopupContainer>
    );
};
